var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobsRouteStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Package"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6 3.91483L9.1 0.904206C8.9162 0.803046 8.7098 0.75 8.5 0.75C8.2902 0.75 8.0838 0.803046 7.9 0.904206L2.4 3.91483C2.2032 4.02251 2.039 4.18117 1.92464 4.37416C1.81027 4.56716 1.74995 4.78737 1.75 5.01171V10.988C1.74995 11.2123 1.81027 11.4325 1.92464 11.6255C2.039 11.8185 2.2032 11.9771 2.4 12.0848L7.9 15.0955C8.08377 15.1967 8.29018 15.2498 8.5 15.2498C8.70982 15.2498 8.91623 15.1967 9.1 15.0955L14.6 12.0848C14.7968 11.9771 14.961 11.8185 15.0754 11.6255C15.1897 11.4325 15.2501 11.2123 15.25 10.988V5.01171C15.2501 4.78737 15.1897 4.56716 15.0754 4.37416C14.961 4.18117 14.7968 4.02251 14.6 3.91483ZM8.5 2.28546L13 4.74983L11.6606 5.48296L7.16062 3.01921L8.5 2.28546ZM8.5 7.21233L4 4.74983L5.5975 3.87483L10.0975 6.33796L8.5 7.21233ZM3.25 6.04921L7.75 8.51171V13.3036L3.25 10.8398V6.04921ZM9.25 13.3036V8.51171L10.75 7.69108V9.49983C10.75 9.69874 10.829 9.88951 10.9697 10.0302C11.1103 10.1708 11.3011 10.2498 11.5 10.2498C11.6989 10.2498 11.8897 10.1708 12.0303 10.0302C12.171 9.88951 12.25 9.69874 12.25 9.49983V6.86983L13.75 6.04921V10.8398L9.25 13.3036Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsRouteStep);
export default __webpack_public_path__ + "static/media/jobs-route-step.67348bf5.svg";
export { ForwardRef as ReactComponent };